// Routing.web.js – version finale qui marche à 100 %
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import {
  SafeAreaProvider,
  SafeAreaView,
  initialWindowMetrics,
} from 'react-native-safe-area-context';
import { Platform } from 'react-native';
import { navigationRef, onNavigationStateChange } from '../lib/navigation';
import { linkingConfig } from './linkingConfig';
import { RootStackNavigator } from './RootStackNavigator';
import { useRouting } from './useRouting';

const edgesByOs = Platform.select({
  android: ['bottom', 'left', 'right'],
  ios: [],
  default: undefined,
}) 

const Routing = () => {
  const { initialRouteName } = useRouting();
  return (
    
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      <SafeAreaView  style={{flex: 1}} edges={edgesByOs}>
        <NavigationContainer
          ref={navigationRef}
          linking={linkingConfig}
          onStateChange={onNavigationStateChange}>
          <RootStackNavigator initialRouteName={initialRouteName} />
        </NavigationContainer>
      </SafeAreaView>
    </SafeAreaProvider>
  );
};

export default Routing;